import { Component, Input } from '@angular/core';
import { ValueRecognitionTableInfos } from '../../models/value-recognition-tables-info.model';

@Component({
  standalone: false,
  selector: 'app-value-recognition-tables',
  templateUrl: './value-recognition-tables.component.html',
  styleUrls: ['./value-recognition-tables.component.scss'],
})
export class ValueRecognitionTablesComponent {
  @Input() readonly!: boolean;
  @Input() tablesInfo!: ValueRecognitionTableInfos;
}
